import { useContext } from 'react';
import { EventContext } from 'state/contexts/event';
import { ProgramContext } from 'state/contexts/program';
import { ProvidersContext } from 'state/contexts/providers';
import { StickyContext } from 'state/contexts/sticky';
import { TagContext } from 'state/contexts/tag';
import { TaskContext } from 'state/contexts/task';
import { ActionTypes as EventActionTypes } from 'state/reducers/event';
import { ActionTypes as ProgramActionTypes } from 'state/reducers/program';
import { ActionTypes as ProviderActionTypes } from 'state/reducers/providers';
import { ActionTypes as StickyActionTypes } from 'state/reducers/sticky';
import { ActionTypes as TagActionTypes } from 'state/reducers/tag';
import { ActionTypes as TaskActionTypes } from 'state/reducers/task';
import AddNewEventNote from './profile/add-new-event-note';
import AddNewSticky from './profile/add-new-sticky-note';
import AddNewTask from './profile/add-new-task';
import AddTag from './profile/add-tag';
import ManagePrograms from './profile/manage-programs/ManagePrograms';
import ManageProvider from './profile/manage-provider';

const MainProfileActions = () => {
  const { stickyState, stickyDispatch } = useContext(StickyContext);
  const { eventState, eventDispatch } = useContext(EventContext);
  const { taskState, taskDispatch } = useContext(TaskContext);
  const { programState, programDispatch } = useContext(ProgramContext);
  const { tagState, tagDispatch } = useContext(TagContext);
  const { providersState, providersDispatch } = useContext(ProvidersContext);

  return (
    <>
      {taskState.modal && (
        <AddNewTask onClose={() => taskDispatch({ type: TaskActionTypes.ToggleModal })} />
      )}
      {stickyState.modal && (
        <AddNewSticky onClose={() => stickyDispatch({ type: StickyActionTypes.ToggleModal })} />
      )}
      {eventState.modal && (
        <AddNewEventNote onClose={() => eventDispatch({ type: EventActionTypes.ToggleModal })} />
      )}
      {programState.modal && (
        <ManagePrograms
          onClose={() => programDispatch({ type: ProgramActionTypes.TOGGLE_MODAL })}
        />
      )}
      {tagState.modal && (
        <AddTag onClose={() => tagDispatch({ type: TagActionTypes.ToggleModal })} />
      )}
      {providersState.modal && (
        <ManageProvider
          onClose={() => providersDispatch({ type: ProviderActionTypes.TOGGLE_MODAL })}
        />
      )}
    </>
  );
};

export default MainProfileActions;
